import React, { useContext } from 'react';
import styles from './roomsPage.module.css'
import Header from '../../components/header/header'
import RoomCard from '../../components/roomCard/roomCard'
import LanguageContext from "../../context/context";


const RoomsPage = () => {
  const language = useContext(LanguageContext);
const data = {
	en: "Prices below change depending on the season. Contact us for more info.",
	ru: "Цены ниже меняются в зависимости от сезона. Для дополнительной информации свяжитесь с нами."
}
return <div className={styles.container}>
	<Header/>
		<h3 className={styles.price}>{data[language.language]}</h3>
		<RoomCard/>
</div>
}

export default RoomsPage
